<template>
<div class="chapter">
<div class="inner_page">
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<blockquote><p class="left"><a id="pv"></a> <em>To Lisa, Caleb, and Maddy.</em><br/>
<em>A beautiful woman. A beautiful son. A beautiful friend.</em></p></blockquote><blockquote><p class="right">—HGB</p></blockquote>
<p class="timebreak"> <br/></p>
<blockquote><p class="left"><em>To Elaine, Bianca, and Devon, and the four-legged companions who have been part of our family. They mean more to me than they did yesterday and less than they will tomorrow.</em></p></blockquote>
<p class="timebreak"> <br/></p>
<blockquote><p class="left"><em>And to the baseball family—those I have competed with and those I have competed against.</em></p></blockquote><blockquote><p class="right">—TLR</p></blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?e908f224